import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import classnames from 'classnames';

import {ADMIN_LINKS} from './AdminLinks';
import LinksMenu from './AppSidebarAdminLinksMenuContainer';
import {envAuth} from '../../../../Login/Redux/LoginReducer';

export const formUrlFromLink = (link: any) => link.route;

export default function AppSidebarAdminLinks(props: any) {
    const {
        roles,
        path,
    } = props;
    
    if (!envAuth && !roles.includes('admin'))
        return null;
    
    const adminURLs = ADMIN_LINKS.map(formUrlFromLink);
    const containerClassName = classnames({
        active: adminURLs.includes(path),
    });
    
    return (
        <ListItem
            className={containerClassName}
            component={LinksMenu}
        />
    );
}
